"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatSSNInput = exports.formatPhoneInput = exports.formatCurrencyInput = exports.formatCardInput = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var formatCardInput = function formatCardInput(string) {
  // setup
  var numberSet = []; // remove any space entered by user

  var cleanedString = Array.from(string.replace(/\s|-/g, ''));

  do {
    // create 4, 4-digit number sets
    // don't care about how long last number set is
    numberSet = [].concat(_toConsumableArray(numberSet), [cleanedString.splice(0, 4).join('')]);
  } while (numberSet.length < 3 && cleanedString.length > 4); // insert spaces between sets


  numberSet = cleanedString.length > 0 ? [].concat(_toConsumableArray(numberSet), [cleanedString.join('')]) : _toConsumableArray(numberSet);
  return numberSet.join(' ');
};

exports.formatCardInput = formatCardInput;

var formatCurrencyInput = function formatCurrencyInput(string) {
  // do nothing with the value if empty
  if (string.length === 0) return string;

  var numberWithCommas = function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }; // removes any $, commas, and spaces entered by user
  // NOTE! We are not removing dots, as this increases complexity on assuming user intent


  var cleanedString = string.replace(/\$|,|\s/g, '');
  var illegalChars = /[^.\d]/g;
  var hasIllegalChars = illegalChars.test(cleanedString);
  var isMissingDollarAmount = Array.from(cleanedString)[0] === '.';
  var isMissingLastCent = Array.from(cleanedString).reverse()[1] === '.';
  var isMissingFistAndLastCent = Array.from(cleanedString).reverse()[0] === '.';
  var hasNoCents = !cleanedString.includes('.');
  if (hasIllegalChars) return cleanedString;
  if (hasNoCents) return "".concat(numberWithCommas(cleanedString), ".00");
  if (isMissingDollarAmount && isMissingLastCent) return "0".concat(numberWithCommas(cleanedString), "0");
  if (isMissingFistAndLastCent) return "".concat(numberWithCommas(cleanedString), "00");
  if (isMissingLastCent) return "".concat(numberWithCommas(cleanedString), "0");
  if (isMissingDollarAmount) return "0".concat(numberWithCommas(cleanedString));
  return numberWithCommas(cleanedString);
};

exports.formatCurrencyInput = formatCurrencyInput;

var formatPhoneInput = function formatPhoneInput(string) {
  // do nothing if any country code other than US +1 is provided
  var nonUSCountryCode = /\+(0|[2-9])/g;
  var hasNonUSCountryCode = nonUSCountryCode.test(string);

  if (hasNonUSCountryCode) {
    return string;
  } // setup


  var numberSet = []; // removes any dots, US country code, spaces, dashes, and parenthesis entered by user

  var cleanedStringAsArray = Array.from(string.replace(/\.|\+1|\s|-|\(|\)/g, '')); // removes 1 as first digit if 9 valid digits are provided after
  // assumes user intent is to provide US country code

  if (cleanedStringAsArray[0] === '1' && cleanedStringAsArray.length === 11) {
    cleanedStringAsArray.shift();
  }

  do {
    // create 2, 3-digit number sets
    // don't care about how long last number set is
    numberSet = [].concat(_toConsumableArray(numberSet), [cleanedStringAsArray.splice(0, 3).join('')]);
  } while (numberSet.length < 2 && cleanedStringAsArray.length > 3); // insert spaces between sets


  numberSet = cleanedStringAsArray.length > 0 ? [].concat(_toConsumableArray(numberSet), [cleanedStringAsArray.join('')]) : _toConsumableArray(numberSet);
  return numberSet.join('-');
};

exports.formatPhoneInput = formatPhoneInput;

var formatSSNInput = function formatSSNInput(string) {
  // setup
  var numberSet = []; // removes any dots, spaces, and dashes entered by user

  var cleanedStringAsArray = Array.from(string.replace(/\.|\s|-/g, ''));
  var setCount;

  switch (true) {
    case cleanedStringAsArray.length < 4:
      setCount = 1;
      break;

    case cleanedStringAsArray.length < 6:
      setCount = 2;
      break;

    default:
      setCount = 3;
      break;
  }

  for (var i = 0; i < setCount; i += 1) {
    // create a 3 digit set
    if (i === 0) {
      numberSet.push(cleanedStringAsArray.splice(0, 3).join(''));
    } // create a 2 digit set


    if (i === 1) {
      numberSet.push(cleanedStringAsArray.splice(0, 2).join(''));
    } // create final set


    if (i === 2) {
      numberSet.push(cleanedStringAsArray.join(''));
    }
  }

  return numberSet.join('-');
};

exports.formatSSNInput = formatSSNInput;